import { IIconProps } from '../../types/IconProps.interface'

export const IconKey = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M12.6514 9.86026C14.4495 8.06213 14.4495 5.14675 12.6514 3.3486C10.8533 1.55046 7.93787 1.55046 6.13974 3.3486C4.94577 4.54256 4.5446 6.2291 4.93621 7.75406C4.99937 8 4.94328 8.266 4.76372 8.4456L2.28899 10.9203C2.07705 11.1323 1.97294 11.429 2.00604 11.7269L2.16075 13.1193C2.17725 13.2678 2.24377 13.4062 2.34939 13.5118L2.48819 13.6506C2.59381 13.7562 2.73223 13.8227 2.88067 13.8393L4.27307 13.9939C4.57097 14.0271 4.86776 13.9229 5.07971 13.711L5.55305 13.2377L4.38895 12.0863C4.19262 11.8921 4.19088 11.5755 4.38507 11.3792C4.57925 11.1829 4.89583 11.1811 5.09217 11.3753L6.26017 12.5305L7.5546 11.2361C7.7342 11.0565 8 11.0006 8.24593 11.0638C9.77087 11.4554 11.4574 11.0542 12.6514 9.86026ZM8.39053 5.72386C8.9112 5.20316 9.75547 5.20316 10.2761 5.72386C10.7969 6.24456 10.7969 7.0888 10.2761 7.60946C9.75547 8.1302 8.9112 8.1302 8.39053 7.60946C7.8698 7.0888 7.8698 6.24456 8.39053 5.72386Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  )
}
